// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import GrowthSvg from '@rsuite/icon-font/lib/application/Growth';
var Growth = createSvgIcon({
  as: GrowthSvg,
  ariaLabel: 'growth',
  category: 'application',
  displayName: 'Growth'
});
export default Growth;